<template lang="pug">
.alert.alert-warning(v-if="err") {{err.message}}
div.mb-sm-3.has-fixed-footer(v-else)
    AdminSubnav(v-if="isAdmin")
    table.table.table-striped
        thead: tr
            th(scope="col") Network
            th(scope="col") Acronym
            th(scope="") Description
            th(scope="") Cohort
        tbody: tr(v-for="network in networks")
            td
                router-link(:to="'/network/' + network.id") {{network.name}}
            td {{ network.acronym }}
            td {{ network.description }}
            td(style="text-align:center")
                i.pi.pi-check(v-if="network.cohort_flag")
    .page-action-footer
        .container
            router-link.btn.btn-success(to="/network-new") Add Network
</template>

<script>
import {getNetworks} from "../api";
import AdminSubnav from "./admin/AdminSubnav.vue";

export default {
    components: {AdminSubnav},
    data() {
        return {
            err: null,
            networks: [],
            isAdmin: localStorage.getItem("is_admin") === "1"
        }
    },
    created() {
        getNetworks()
        .then(networks => this.networks = networks)
        .catch(err => this.err = err);
    },
}
</script>
